import React from "react";
import { MapPin, Phone, Mail, MessageCircle, Clock } from "lucide-react";

export default function Contact() {
  return (
    <div className="max-w-5xl mx-auto px-6 md:px-12 py-20">
      <div className="ornament mb-4">Get in Touch</div>
      <h1 className="font-display text-5xl md:text-6xl text-navy-900 leading-tight" style={{ fontWeight: 500 }}>Come by the showroom.</h1>
      <p className="mt-5 text-navy-900/70 max-w-xl">Sit, take tea, try the pieces on. The catalogue is a window — the showroom is the room.</p>

      <div className="grid md:grid-cols-2 gap-10 mt-14">
        <div className="space-y-6 text-sm">
          <Item icon={<MapPin />} label="Visit us" lines={["SCO 33, Sector 8-B", "Chandigarh — 160 009"]} />
          <Item icon={<Phone />} label="Call us" lines={["+91 78148 54580"]} link="tel:+917814854580" />
          <Item icon={<MessageCircle />} label="WhatsApp" lines={["+91 78148 54580"]} link="https://wa.me/917814854580" />
          <Item icon={<Mail />} label="Email" lines={["bholaajewels@gmail.com"]} link="mailto:bholaajewels@gmail.com" />
          <Item icon={<Clock />} label="Hours" lines={["Monday – Saturday", "10:30 AM – 8:00 PM"]} />
        </div>
        <div className="aspect-square md:aspect-auto md:min-h-[460px] overflow-hidden border border-gold/40 rounded-sm">
          <iframe
            title="Bholaa Jewels — SCO 33, Sector 8-B, Chandigarh"
            src="https://www.google.com/maps?q=SCO+33,+Sector+8B,+Chandigarh&output=embed"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            allowFullScreen
            className="w-full h-full border-0"
          />
        </div>
      </div>
    </div>
  );
}

const Item = ({ icon, label, lines, link }) => (
  <div className="flex gap-4 items-start" data-testid={`contact-${label.toLowerCase().replace(/\s/g,'-')}`}>
    <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center border border-gold/50 text-gold">
      {React.cloneElement(icon, { className: "w-4 h-4", strokeWidth: 1.5 })}
    </div>
    <div>
      <div className="overline text-gold mb-1">{label}</div>
      {lines.map((l) => (
        link ? <a key={l} href={link} className="block text-navy-900 hover:text-gold transition-colors">{l}</a> : <div key={l} className="text-navy-900/85">{l}</div>
      ))}
    </div>
  </div>
);
